import {
  previewSelection,
  resetRefiners,
  reviewSelection,
} from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import ProductRefiner from "components/Stacker/components/ProductRefiner/ProductRefiner"
import PropTypes from "prop-types"
import queryString from "query-string"
import React, { useCallback, useContext } from "react"
import "./ProductReviewSelection.scss"
import { AEM_ASSETS } from "components/Stacker/AEMConstants"
import { InlineSVGIcon } from "components/Stacker/SvgIcon"
import iconArrowBack from "assets/temp/icons/icon-arrow-back.svg"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"
import { getDYArea } from "stackerConfig"
import { StackerContext } from "components/DYStackers/StackerContext"

function ProductReviewSelection({ className, productType }) {
  const stackerContext = useContext(StackerContext)
  const { LL } = useI18nContext()
  const dispatch = useDispatch()
  const {
    amuletProducts,
    cartMetaData,
    isCsAgent,
    isReviewing,
    pdp,
    refinerMap,
    refiners,
  } = useSelector((state) => {
    return {
      amuletProducts: state.stacker.products,
      cartMetaData: state.cart.meta,
      isEPS: state.application.isEPS,
      isCsAgent: false,
      isReviewing: state.stacker.isReviewing,
      pdp: state.pdp,
      refinerMap: state.stacker.refinerMap,
      refiners: state.stacker.refiners,
    }
  })

  const onModifyClick = useCallback(
    (e) => {
      e.preventDefault()
      dispatch(resetRefiners())
      dispatch(reviewSelection(false))
      //dispatch(previewSelection(true))
    },
    [dispatch]
  )

  if (!isReviewing) return null

  function getProductByVariant(item) {
    return amuletProducts.filter((amulet) => {
      return item === amulet.variants[0].code
    })[0]
  }

  function getQueryProducts() {
    const queryObj = queryString.parse(window.location.search, { decode: true })
    if (!queryObj.products) return null

    let products = Array.isArray(queryObj.products)
      ? queryObj.products
      : [queryObj.products]
    if (productType === "amulets") {
      products = Array.isArray(queryObj.products)
        ? [queryObj.chainBaseProduct, ...queryObj.products]
        : [queryObj.chainBaseProduct, ...[queryObj.products]]
    }
    return products
  }

  function getProductList() {
    const products = getQueryProducts()

    if (!products || !amuletProducts.length) return null

    return products.map((id, i) => {
      const refinerId = refinerMap[i]
      const refiner = refiners[refinerId]
      const baseId = refiner.pid.substr(0, 9)
      const productDetails = pdp[baseId]

      if (!productDetails || !productDetails.meta) return null

      const updatedProductDetails = {
        ...productDetails,
        selectedVariant: refiner.selectedVariant,
        selectedVariantIndex: refiner.selectedVariantIndex,
      }

      return (
        <ProductRefiner
          cartMetaData={cartMetaData}
          isCsAgent={isCsAgent}
          isRequired={isCsAgent}
          key={i}
          refiner={refiner}
          refinerId={refinerId}
          productDetails={updatedProductDetails}
          productType={productType}
        />
      )
    })
  }

  const productList = getProductList()

  const reviewClass = classNames(
    "product_list",
    "product_list-review",
    "h-100",
    "w-100",
    className
  )

  const imgSrc =
    stackerContext.gender == "men"
      ? `${AEM_ASSETS}/temp/icons/men-s-icon-arrow-left.svg`
      : `${AEM_ASSETS}/temp/icons/icon-arrow-back.svg`

  return (
    <section className={reviewClass}>
      <div className="product_list-header">
        <div className="list-header position-relative mb-0 mb-xl-2 mb-lg-0 text-uppercase">
          <div className="list-header-button-left">
            <button
              className="btn btn-std text-uppercase border-0 d-none d-lg-block"
              onClick={onModifyClick}
            >
              <img
                alt="Back"
                className="d-inline mr-1"
                height="11"
                src={imgSrc}
              />
              <span style={{ lineHeight: "20px" }}>
                {LL[getDYArea()].modify()}
              </span>
            </button>
            <button
              className={"btn btn-icon icon icon-back icon-modify d-lg-none"}
              onClick={onModifyClick}
            >
              <InlineSVGIcon
                alt={LL[getDYArea()].reviewSelection()}
                className={"mr-1"} //d-inline
                style={{
                  display: "inline-block",
                  height: 11,
                  width: 6.7,
                  position: "relative",
                  top: -5,
                  left: -5,
                }}
                iconSvgText={iconArrowBack}
              />
            </button>
            {/*
							<button
								style={{
									backgroundImage: getIsMensExperience()
										? `url(${imgSrc})`
										: undefined
								}}
								className="btn btn-icon icon icon-back icon-modify d-lg-none"
								onClick={this.onModifyClick}
							/>
*/}
          </div>
          <div className="list-header-description text-center text-black">
            {LL[getDYArea()].reviewSelection()}
          </div>
        </div>
      </div>
      <div
        className="product_list-body flex-grow-1"
        style={{ overflow: "scroll" }}
      >
        {productList}
      </div>
    </section>
  )
}

ProductReviewSelection.propTypes = {
  className: PropTypes.string,
  productType: PropTypes.string.isRequired,
}

export default ProductReviewSelection
